import { type LucideIcon } from 'lucide-react';
import { motion } from 'motion/react';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact,
}: {
  icon: LucideIcon;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  compact?: boolean;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'gap-2 px-4 py-8' : 'gap-3 px-6 py-16',
        className,
      )}
    >
      <div className="relative">
        <div className="absolute inset-0 scale-150 rounded-full bg-accent-soft blur-xl" aria-hidden />
        <div className="relative flex size-12 items-center justify-center rounded-xl border border-border bg-surface text-primary-text shadow-e2">
          <Icon className="size-5" aria-hidden />
        </div>
      </div>
      <h3 className="mt-2 font-display text-base font-semibold text-fg">{title}</h3>
      {description && <p className="max-w-sm text-sm text-fg-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </motion.div>
  );
}
